import { useState } from 'react';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { ChevronDownIcon, } from '@heroicons/react/20/solid';
import {
  BanknotesIcon,
  BookOpenIcon,
  ChatBubbleLeftEllipsisIcon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';
import { NavLink } from 'react-router-dom';
import { Cache } from 'aws-amplify/utils';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { randomBackgroundColorForAvatar } from '../../utilities';

// providers
import { useUserContext } from '../../providers/user';

export default function HeaderUserSettings(props) {

  // input
  const { name = '' } = props;

  // hooks
  const { signOut } = useAuthenticator((context) => [context.user]);

  // states
  const [settings, setSettings] = useState([
    { name: 'Documentation', description: 'Step by step to build you IoT application', href: 'https://docs.neuko.io', target: '_blank', icon: BookOpenIcon },
    { name: 'Help Desk', description: "Get help from our customer service", href: 'https://neuko.atlassian.net/servicedesk/customer/portal/1', target: '_blank', icon: ChatBubbleLeftEllipsisIcon },
  ]);

  const onLogOutClicked = async () => {
    await Cache.clear();
    signOut();
  }

  return (
    <Popover className="relative pr-6 justify-between">
      <PopoverButton className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
        <span className={`inline-flex right-4 h-8 w-8 items-center justify-center rounded-full ${randomBackgroundColorForAvatar()}`}>
          <span className="text-sm font-medium leading-none text-white">{name?.substring(0, 1)}</span>
        </span>
        <span className='pl-4'>{name}</span>
        <ChevronDownIcon aria-hidden="true" className="h-5 w-5" />
      </PopoverButton>

      <PopoverPanel
        transition
        className="absolute left-0 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 px-4 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
          <div className="p-4">
            {/* Change password */}
            <div key={'change-password'} className="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50">
              <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                <ShieldCheckIcon aria-hidden="true" className="h-6 w-6 text-gray-600 group-hover:text-indigo-600" />
              </div>
              <div>
                <NavLink className="font-semibold text-gray-900" to={'/change-password'}>
                  Change Password
                  <span className="absolute inset-0" />
                </NavLink>
                <p className="mt-1 text-gray-600">Secure your account with strong passwordt</p>
              </div>
            </div>

            {/* The rest */}
            {settings.map((item) => (
              <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50">
                <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                  <item.icon aria-hidden="true" className="h-6 w-6 text-gray-600 group-hover:text-indigo-600" />
                </div>
                <div>
                  <a href={item.href} target={item.target} className="font-semibold text-gray-900">
                    {item.name}
                    <span className="absolute inset-0" />
                  </a>
                  <p className="mt-1 text-gray-600">{item.description}</p>
                </div>
              </div>
            ))}

            {/* Log out */}
            <div key={'log-out'} className="group relative flex gap-x-6 rounded-lg p-4 hover:bg-red-50">
              <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-red-50 group-hover:bg-white">
                <BanknotesIcon aria-hidden="true" className="h-6 w-6 text-red-600 group-hover:text-red-600" />
              </div>
              <div>
                <a className="font-semibold text-red-500" onClick={() => onLogOutClicked()}>
                  Log Out
                  <span className="absolute inset-0" />
                </a>
                <p className="mt-1 text-red-600">Securely logging out from session</p>
              </div>
            </div>
          </div>
        </div>
      </PopoverPanel>
    </Popover>
  )
}
